export enum Locales {
    en = 'en',
    fr = "fr",
    de = "de",
    es = "es"
}

export const LOCALES = [
    {
        value: Locales.en,
        caption: 'English'
    },
    {
        value: Locales.fr,
        caption: 'Français'
    },
    {
        value: Locales.de,
        caption: 'Deutsch'
    },
    {
        value: Locales.es,
        caption: 'Español'
    }
]